import { render, staticRenderFns } from "./AgreementModal.vue?vue&type=template&id=2b0f7118&scoped=true&lang=pug&"
import script from "./AgreementModal.vue?vue&type=script&lang=ts&"
export * from "./AgreementModal.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementModal.vue?vue&type=style&index=0&id=2b0f7118&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0f7118",
  null
  
)

export default component.exports